"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Logo_less_1 = __importDefault(require("./Logo.less"));
var Logo = function (_a) {
    var _b;
    var src = _a.src, name = _a.name;
    var imageRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(false), loaded = _c[0], setLoaded = _c[1];
    var _d = (0, react_1.useState)(false), failed = _d[0], setFailed = _d[1];
    var onLoad = (0, react_1.useCallback)(function (event) {
        setLoaded(event.currentTarget.naturalWidth > 0);
    }, []);
    var onError = (0, react_1.useCallback)(function () { return setFailed(true); }, []);
    (0, react_1.useEffect)(function () {
        var image = imageRef.current;
        if (image !== null && image.complete && image.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [src]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loaded ?
            null
            :
                react_1.default.createElement("div", { className: Logo_less_1.default['name'] }, name),
        src !== null && !failed ?
            react_1.default.createElement("img", { ref: imageRef, className: (0, classnames_1.default)(Logo_less_1.default['logo'], (_b = {}, _b[Logo_less_1.default['loading']] = !loaded, _b)), src: src, alt: '', onLoad: onLoad, onError: onError })
            :
                null));
};
exports.default = Logo;
